(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        /**
         * @memberOf Lfl.Forms
         */
        Lfl.Forms.Inputs = Forms.Inputs || {};

        (function (Inputs, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.Forms.Inputs, 'TextareaAutoresizer')) {
                return;
            }

            /*
             |==========================================================================================================
             | Class definition
             |==========================================================================================================
             */

            /**
             * Sets up a given textarea to be resized automatically based on content.
             *
             * @param {object} parameters
             * @param {jQuery} [parameters.$area] The jquery object of this textarea.
             * @param {string} [parameters.areaPath] Alternatively: The path to the textarea.
             * Later: Passing of $area/areaPath could be refactored to be like the $linkedArea.
             * @param {int} [parameters.maximumOversize] Maximum empty space in the text area before it is shrunk (for
             * example, if user first types in long text and then deletes a part of it).
             * @param {object} [parameters.linkedResizable] An optional set of parameters of the linked resizable.
             * @param {jQuery} [parameters.linkedResizable.$linked] Defines an element that fills the remainder of the
             * element in which the textArea (or it's wrapper) resides - i.e., it's size is linked to the size of the
             * area.
             * @param {jQuery} [parameters.linkedResizable.$areaWrapper] Defines an element that wraps the area on the
             * same level as the linked element is. If not defined, the area itself is used.
             * Later: The wrapper could be computed - ResizableTextArea::ResizeLinkedElement::DetectWrapperAutomatically
             * @memberOf Lfl.Forms.Inputs
             * @lends Lfl.Forms.Inputs.TextareaAutoresizer
             * @constructor
             */
            Lfl.Forms.Inputs.TextareaAutoresizer = function (parameters) {
                if (typeof parameters.$area === 'undefined' && typeof parameters.areaPath === 'undefined') {
                    throw new Error("One of `elementPath` or `$element` have to be defined.")
                }

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Construction
                 |------------------------------------------------------------------------------------------------------
                 */
                var $area;
                var maximumOversize;
                var originalHeight;
                // Pseudo-constant, not expected to change.
                var DEBOUNCE_WAIT = 200;
                var $clone;

                // Linked area variables.
                var $linked;
                /**
                 * Wrapper of the area on the same level of the $linked. Or the area itself.
                 */
                var $wrapper;
                var $parent;

                // Nothing initialized in advance.

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Public methods
                 |------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Initializes the mechanism.
                 */
                this.init = function () {
                    initVariables();

                    $area.on('input', reactToChange);
                    $(window).on('resize', _.debounce(reactToChange, DEBOUNCE_WAIT));
                };

                /*
                 |------------------------------------------------------------------------------------------------------
                 | Private methods
                 |------------------------------------------------------------------------------------------------------
                 */

                function initVariables() {
                    if (typeof parameters.$area === 'undefined') {
                        $area = $(parameters.areaPath);
                    } else {
                        $area = parameters.$area;
                    }

                    $clone = createClone($area).appendTo($area.parent());

                    originalHeight = $area.innerHeight();
                    maximumOversize = parameters.hasOwnProperty("maximumOversize")
                        ? parameters.maximumOversize
                        : Lfl.Forms.Inputs.TextareaAutoresizer.DEFAULT_MAX_OVERSIZE;

                    if (typeof parameters.linkedResizable !== 'undefined') {
                        if (!(parameters.linkedResizable.$linked instanceof jQuery)) {
                            throw new Error("The $linked must be passed in as jQuery.");
                        }

                        $linked = parameters.linkedResizable.$linked;
                        $wrapper = parameters.linkedResizable.$areaWrapper;

                        if (typeof $wrapper === 'undefined') {
                            $wrapper = $area;
                        }

                        $parent = $wrapper.parent();
                        var $linkedParent = $linked.parent();

                        if (true !== $linkedParent.is($parent)) {
                            throw new Error("Parents do not match!" + ' `' + FullDomPathProvider.getFullDomPath($parent) +
                                '` vs. `' + FullDomPathProvider.getFullDomPath($linkedParent) + '`');
                        }

                        if ($parent.innerHeight() !== ($linked.outerHeight() + $wrapper.outerHeight())) {
                            console.warn("Warning: the parent's height does not match the sum of the heights" +
                                "of the textarea (or it's wrapper) and the linked area! " + $parent.innerHeight() +
                                " !== " + $linked.outerHeight() + $wrapper.outerHeight());
                        }
                    }
                }

                function createClone($area) {
                    var $clone = $area.clone();

                    // Remove attributes that could confuse it for the original $area.
                    $clone.attr('id', $area.attr('id') ? $area.attr('id') + '-autoresizer-clone' : undefined);
                    $.each($clone.data(), function (i) {
                        $clone.removeAttr("data-" + Lfl.String.toKebab(i));
                        $clone.removeData(i);
                    });

                    // Identify the clones (we do not want any unexpected order 66, do we?)
                    $clone.attr('data-lfl-autoresizer-role', 'clone');
                    $clone.data('lfl-autoresizer-role', 'clone');

                    // Hide it
                    $clone.css('position', 'absolute');
                    $clone.css('visibility', 'hidden');
                    $clone.css('top', '0');

                    return $clone;
                }

                function reactToChange() {
                    var height = $area.innerHeight();
                    $clone.val($area.val());
                    $clone.innerHeight(0);

                    var scrollHeight = $clone.prop('scrollHeight');

                    if (scrollHeight > height) {
                        setAreaHeight(scrollHeight);
                    } else {
                        // Note: The max-height CSS property affects the actual result, effectively limiting this value.
                        var currentMaxHeight = Math.max(originalHeight, scrollHeight + maximumOversize);

                        if (height > currentMaxHeight) {
                            // Make smaller
                            setAreaHeight(currentMaxHeight);
                        } else {
                            // Do nothing
                        }
                    }
                }

                function setAreaHeight(height) {
                    $area.innerHeight(height);

                    if (typeof $linked !== 'undefined') {
                        $linked.outerHeight($parent.innerHeight() - $wrapper.outerHeight());
                    }
                }
            };

            /*
             |==========================================================================================================
             | Static constants
             |==========================================================================================================
             */
            /**
             * The default value, in pixels, of the maximum empty space in textarea before it begins to shrink.
             * @type {number}
             * @memberOf Lfl.Forms.Inputs.TextareaAutoresizer
             */
            Lfl.Forms.Inputs.TextareaAutoresizer.DEFAULT_MAX_OVERSIZE = 0;
            /**
             * A path to textareas with special configuration that can be used to define areas to have the autoresize
             * turned on by default.
             * @type {string}
             * @memberOf Lfl.Forms.Inputs.TextareaAutoresizer
             */
            Lfl.Forms.Inputs.TextareaAutoresizer.GENERAL_AREA_PATH = 'textarea[lfl-textarea-autoresize="true"]';
        }(Forms.Inputs, jQuery));
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
